import { createFileRoute, Outlet } from "@tanstack/react-router";
import MotionLazyContainer from "src/components/animate/MotionLazyContainer";
import { ChartStyle } from "src/components/chart";
import NotistackProvider from "src/components/NotistackProvider";
import AuthProvider from "src/providers/AuthProvider/AuthProvider";
import ThemeProvider from "src/providers/ThemeProvider";

export const Route = createFileRoute("/_dashboard")({
	component: () => (
		<ThemeProvider>
			<NotistackProvider>
				<AuthProvider>
					<MotionLazyContainer>
						<ChartStyle />
						<Outlet />
					</MotionLazyContainer>
				</AuthProvider>
			</NotistackProvider>
		</ThemeProvider>
	)
});
